/* CAP Configuratore v1 — Cappellino M.R.A. */
(function () {
  'use strict';

  var BASE_PRICE = 15.00;
  var ADDON_PRICE = 5.00;

  var state = {
    colore: 'nero',
    lati: 'nessuno',    // 'nessuno' | 'nome_dx' | 'nome_sx' | 'nome_entrambe'
    testo_nome: '',
    totalPrice: BASE_PRICE,
    addons: 0
  };

  var IMAGES = (window.CAP_PRODUCT && window.CAP_PRODUCT.images) || {};

  function img(key) {
    if (!key) return '';
    if (state.colore === 'grigio') {
      var grey = key.replace(/^cap-/, 'cap-G-');
      if (IMAGES[grey]) return IMAGES[grey];
    }
    return IMAGES[key] || '';
  }

  function getDxKey() {
    if (state.lati === 'nome_dx' || state.lati === 'nome_entrambe') return 'cap-LATERALE-DX-NOME';
    return 'cap-CLEAN-DX';
  }

  function getSxKey() {
    if (state.lati === 'nome_sx' || state.lati === 'nome_entrambe') return 'cap-LATERALE-SX-NOME';
    return 'cap-CLEAN-SX';
  }

  /* ============================================================
     DROP GATE
     ============================================================ */
  var dropConfig = { enabled: false, dropTime: null, label: '' };
  var countdownTimer = null;

  function parseRomeDateTime(dateStr, timeStr) {
    if (!dateStr) return null;
    var dp = dateStr.split('-');
    if (dp.length !== 3) return null;
    var y = +dp[0], mo = +dp[1], d = +dp[2], h = 0, mi = 0;
    if (timeStr) { var tp = timeStr.split(':'); h = +tp[0] || 0; mi = +tp[1] || 0; }
    if (isNaN(y) || isNaN(mo) || isNaN(d)) return null;
    var guess = Date.UTC(y, mo - 1, d, h, mi, 0);
    var off = getTimezoneOffsetMinutes('Europe/Rome', guess);
    var real = guess - off * 60000;
    var off2 = getTimezoneOffsetMinutes('Europe/Rome', real);
    if (off2 !== off) real = guess - off2 * 60000;
    return new Date(real);
  }

  function getTimezoneOffsetMinutes(tz, utcMs) {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      });
      var parts = fmt.formatToParts(new Date(utcMs));
      var o = {};
      parts.forEach(function (p) { if (p.type !== 'literal') o[p.type] = p.value; });
      var asUtc = Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
      return Math.round((asUtc - utcMs) / 60000);
    } catch (e) {
      var m = new Date(utcMs).getUTCMonth() + 1;
      return (m >= 4 && m <= 9) ? 120 : 60;
    }
  }

  function isPurchaseLive() {
    if (!dropConfig.enabled) return false;
    if (!dropConfig.dropTime) return true;
    return Date.now() >= dropConfig.dropTime.getTime();
  }

  function isPreDrop() {
    if (isPurchaseLive()) return false;
    return dropConfig.dropTime && Date.now() < dropConfig.dropTime.getTime();
  }

  function startCountdown() {
    stopCountdown();
    if (!dropConfig.dropTime) return;
    renderCountdown();
    countdownTimer = setInterval(function () {
      renderCountdown();
      if (isPurchaseLive()) { stopCountdown(); updateAll(); }
    }, 1000);
  }

  function stopCountdown() {
    if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
  }

  function renderCountdown() {
    if (!dropConfig.dropTime) return;
    var diff = Math.max(0, dropConfig.dropTime.getTime() - Date.now());
    var ts = Math.floor(diff / 1000);
    var dd = Math.floor(ts / 86400);
    var hh = Math.floor((ts % 86400) / 3600);
    var mm = Math.floor((ts % 3600) / 60);
    var ss = ts % 60;
    root.querySelectorAll('[data-role="countdown"]').forEach(function (c) {
      var d = c.querySelector('[data-unit="days"]');
      var h = c.querySelector('[data-unit="hours"]');
      var m = c.querySelector('[data-unit="minutes"]');
      var s = c.querySelector('[data-unit="seconds"]');
      if (d) d.textContent = pad(dd);
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
    });
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ============================================================
     PREZZO
     ============================================================ */
  function calculatePrice() {
    var chunks = 0;
    if (state.lati === 'nome_dx' || state.lati === 'nome_sx') chunks += 1;
    else if (state.lati === 'nome_entrambe') chunks += 2;
    state.addons = chunks;
    state.totalPrice = BASE_PRICE + chunks * ADDON_PRICE;
  }

  function formatPrice(n) {
    return '\u20AC' + n.toFixed(2).replace('.', ',');
  }

  function parseEuro(val, fb) {
    if (!val) return fb;
    var n = parseFloat(String(val).replace(',', '.'));
    return isNaN(n) ? fb : n;
  }

  /* ============================================================
     VARIANTI — option-order agnostic
     ============================================================ */
  function resolveOptionSlots() {
    var names = (window.CAP_PRODUCT && window.CAP_PRODUCT.option_names) || [];
    var slots = { color: -1, addon: -1 };
    names.forEach(function (n, i) {
      var nm = String(n || '').toLowerCase().trim();
      if (/color/.test(nm)) slots.color = i;
      else if (/addon|opzion|person|^_?p$/.test(nm)) slots.addon = i;
    });
    return slots;
  }

  function findVariant() {
    if (!window.CAP_PRODUCT) return null;
    var variants = window.CAP_PRODUCT.variants;
    var slots = resolveOptionSlots();
    var colorLabel = state.colore === 'grigio' ? 'Grigio Scuro' : 'Nero';

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      var opts = v.options || [];
      var colorMatch = slots.color < 0 || opts[slots.color] === colorLabel;
      var addonMatch = slots.addon < 0 || String(opts[slots.addon]) === String(state.addons);
      if (colorMatch && addonMatch) return v;
    }
    // fallback: first available
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].available) return variants[j];
    }
    return null;
  }

  /* ============================================================
     DOM
     ============================================================ */
  var root;

  function init() {
    root = document.querySelector('.cap-configurator');
    if (!root) return;

    var enabled = root.getAttribute('data-purchase-enabled') === 'true';
    var dt = parseRomeDateTime(
      root.getAttribute('data-drop-date') || '',
      root.getAttribute('data-drop-time') || ''
    );
    dropConfig = {
      enabled: enabled,
      dropTime: dt,
      label: root.getAttribute('data-drop-label') || 'Disponibile al drop'
    };

    bindEvents();
    if (isPreDrop()) startCountdown();
    updateAll();
  }

  function bindEvents() {
    root.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        var name = e.target.name;
        if (name === 'cap_colore') state.colore = e.target.value;
        if (name === 'cap_lati') state.lati = e.target.value;
        updateAll();
        if (name === 'cap_lati') {
          if (state.lati === 'nome_sx') showZone('sx');
          else if (state.lati === 'nome_dx' || state.lati === 'nome_entrambe') showZone('dx');
          else showZone('fronte');
        }
        if (name === 'cap_colore') refreshThumbnails();
      }
    });

    var nomeField = root.querySelector('#cap-nome-text');
    if (nomeField) {
      nomeField.addEventListener('input', function () {
        this.value = this.value.replace(/[^A-Za-z\u00C0-\u00FF\s]/g, '');
        state.testo_nome = this.value.trim().toUpperCase();
      });
    }

    root.querySelectorAll('.cap-preview__dot').forEach(function (dot) {
      dot.addEventListener('click', function () {
        showZone(this.getAttribute('data-zone'));
      });
    });

    var buyBtn = root.querySelector('[data-role="buy-button"]');
    if (buyBtn) buyBtn.addEventListener('click', onBuy);
  }

  function refreshThumbnails() {
    /* se servono thumbnail nelle card, aggiorna qui */
  }

  /* ============================================================
     UPDATE
     ============================================================ */
  function updateAll() {
    calculatePrice();
    updateImages();
    updateNomeInput();
    updatePriceDisplay();
    updateDropUI();
  }

  function updateImages() {
    var urls = {
      fronte: img('cap-FRONTE'),
      dx: img(getDxKey()),
      sx: img(getSxKey())
    };
    root.querySelectorAll('.cap-preview__img').forEach(function (el) {
      var zone = el.getAttribute('data-zone');
      if (urls[zone]) el.src = urls[zone];
    });
  }

  function needsNome() {
    return state.lati === 'nome_dx' || state.lati === 'nome_sx' || state.lati === 'nome_entrambe';
  }

  function updateNomeInput() {
    var box = root.querySelector('.cap-nome-input');
    if (box) box.style.display = needsNome() ? '' : 'none';
  }

  function updatePriceDisplay() {
    var preDrop = isPreDrop();
    var totalBlock = root.querySelector('[data-role="total-block"]');
    if (totalBlock) totalBlock.style.display = preDrop ? 'none' : '';

    var priceEl = root.querySelector('.cap-total__price');
    if (priceEl) priceEl.textContent = formatPrice(state.totalPrice);

    root.setAttribute('data-pre-drop', preDrop ? 'true' : 'false');
  }

  function updateDropUI() {
    var preDrop = isPreDrop();
    var live = isPurchaseLive();

    var cd = root.querySelector('[data-role="countdown"]');
    if (cd) cd.style.display = preDrop ? '' : 'none';

    var btn = root.querySelector('[data-role="buy-button"]');
    if (!btn) return;
    var textEl = btn.querySelector('.cap-buy__text');

    if (preDrop || !dropConfig.enabled) {
      btn.disabled = true;
      btn.classList.add('cap-buy--locked');
      if (textEl) textEl.textContent = dropConfig.label || 'Acquisto non disponibile';
    } else if (live) {
      btn.disabled = false;
      btn.classList.remove('cap-buy--locked');
      if (textEl) textEl.textContent = 'ACQUISTA ORA';
    }
  }

  /* ============================================================
     CAROUSEL
     ============================================================ */
  function showZone(zone) {
    root.querySelectorAll('.cap-preview__img').forEach(function (el) {
      el.classList.toggle('active', el.getAttribute('data-zone') === zone);
    });
    root.querySelectorAll('.cap-preview__dot').forEach(function (dot) {
      dot.classList.toggle('active', dot.getAttribute('data-zone') === zone);
    });
  }

  /* ============================================================
     BUY
     ============================================================ */
  function onBuy() {
    if (!isPurchaseLive()) return;
    if (needsNome() && !state.testo_nome) {
      var f = root.querySelector('#cap-nome-text');
      if (f) { f.focus(); f.classList.add('cap-nome-input__field--error'); setTimeout(function () { f.classList.remove('cap-nome-input__field--error'); }, 1500); }
      return;
    }

    var variant = findVariant();
    if (!variant) { alert('Combinazione non disponibile.'); return; }

    var colorLabel = state.colore === 'grigio' ? 'Grigio Scuro' : 'Nero';
    var latiLabels = {
      nessuno: 'Nessuno',
      nome_dx: 'Nome lato destro',
      nome_sx: 'Nome lato sinistro',
      nome_entrambe: 'Nome su entrambi i lati'
    };
    var latiStaff = {
      nessuno: 'VUOTO',
      nome_dx: 'NOME-LATO-DX',
      nome_sx: 'NOME-LATO-SX',
      nome_entrambe: 'NOME-LATO-DX + NOME-LATO-SX'
    };

    var properties = {
      'Colore': colorLabel,
      'Lati': latiLabels[state.lati] || 'Nessuno',
      '_Colore': state.colore.toUpperCase(),
      '_Lati': latiStaff[state.lati] || 'VUOTO'
    };
    if (needsNome() && state.testo_nome) {
      properties['Nome personalizzato'] = state.testo_nome;
      properties['_Testo da stampare'] = state.testo_nome;
    }
    properties['_Num addons'] = String(state.addons);

    var imgFronte = img('cap-FRONTE');
    var imgDx = img(getDxKey());
    var imgSx = img(getSxKey());
    if (imgFronte) properties['_Img Fronte'] = 'https:' + imgFronte;
    if (imgDx) properties['_Img Destra'] = 'https:' + imgDx;
    if (imgSx) properties['_Img Sinistra'] = 'https:' + imgSx;

    var btn = root.querySelector('[data-role="buy-button"]');
    var textEl = btn.querySelector('.cap-buy__text');
    var loadEl = btn.querySelector('.cap-buy__loading');
    if (textEl) textEl.style.display = 'none';
    if (loadEl) loadEl.style.display = '';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1, properties: properties })
    })
    .then(function (res) { if (!res.ok) throw new Error('Errore'); return res.json(); })
    .then(function () { window.location.href = '/checkout'; })
    .catch(function (err) {
      alert('Errore: ' + err.message);
      if (textEl) textEl.style.display = '';
      if (loadEl) loadEl.style.display = 'none';
      btn.disabled = false;
    });
  }

  /* ============================================================
     AVVIO
     ============================================================ */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
